// InviteeJoinPage.jsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiClient from './api/apiClient';

function InviteeJoinPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError("Invalid link.");
      return;
    }
    fetchMeetingDetailsAndProceed();

  }, [token]);

const fetchMeetingDetailsAndProceed = async ()=>{
  try{
    console.log("token is ",token);
    const response = await apiClient.post('/invites/validate',{token});
    console.log("Response is ",response.data);
    navigate(`/meetingroom/${response.data.roomId}/${response.data.meetingId}`,{state:{isInitiator:false}})
  }catch(error){
    console.log("Error getting details from token ",error);
  }
 }
}
export default InviteeJoinPage;
